<template>
  <a-modal
    v-model:visible="visible"
    wrap-class-name="modal-template-list"
    :width="1136"
    title="模板库"
    :footer="null"
  >
    <div class="flex pt-5 h-full">
      <!-- left -->
      <div class="w-40 px-3 flex flex-col justify-between pb-6">
        <div class="">
          <div
            v-for="(item, index) in templetTypes"
            :key="index"
            class="h-15 w-full px-5 py-3 mb-2.5 rounded-lg hover:bg-[#333]/[0.5] flex items-center"
            :class="{
              'bg-[#333]': isActive(index),
              'opacity-[1]': isActive(index),
              'opacity-[0.7]': !isActive(index)
            }"
            @click="handleClick(index)"
          >
            <span
              class="text-xl text-[#FFF]"
              :class="{
                'font-thin': !isActive(index),
                'font-normal': isActive(index)
              }"
            >
              {{ item }}
            </span>
          </div>
        </div>
        <div class="flex flex-col items-center">
          <a-button class="" @click="exportAll"> 全部导出 </a-button>
          <a-button class="mt-2.5" @click="importTemplates">导入</a-button>
          <!-- <a-button
            v-if="isDev"
            class="w-28 h-10 text-sm border-none bg-[#333] hover:bg-[#333]/[0.5] rounded-lg mb-5"
            @click="deleteAll"
            >清空</a-button
          > -->
        </div>
      </div>
      <!-- right -->
      <div
        class="flex-1 bg-[#1E1E1E] rounded-t-2xl overflow-auto frame-select-scroll-container mx-6 h-full"
      >
        <templet-list
          v-if="visible"
          :templates="templates"
          :active-index="activeIndex"
          @update="
            async () => {
              templates = await templateService.readTemplates();
            }
          "
          @close-modal="() => (visible = false)"
        />
      </div>
    </div>
  </a-modal>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import {
  TemplateService,
  WatchfaceTemplateItem
} from '@/services/template.service';
import { pickFile } from '@/utils/fs/pick-file.utils';
import { notification } from 'ant-design-vue';
const templateService = new TemplateService();
const templates = ref<WatchfaceTemplateItem[] | undefined>([]);
const visible = ref<boolean>(false);
const showModal = async () => {
  templates.value = await templateService.readTemplates();
  visible.value = true;
};

defineExpose({ showModal });

//导入模板
const importTemplates = async () => {
  try {
    let picked = await pickFile({ extensions: ['zip'] }).then((r) => r?.[0]);
    if (picked) {
      await templateService.importTemplates(picked as string);
      notification.open({
        message: '导入成功'
      });
    }
  } catch (e) {
    notification.error({
      message: '错误',
      description: '导入失败'
    });
  } finally {
    templates.value = await templateService.readTemplates();
  }
};

//导出全部模板
const exportAll = async () => {
  try {
    const toExport = templates?.value?.map((t) => t.id);
    if (toExport) {
      await templateService.exportTemplates(toExport);
    }
  } catch (e) {
    notification.error({
      message: '错误',
      description: '导出失败'
    });
  }
};

//清空模板(用于调试)
// const deleteAll = async () => {
//   if (templates?.value) {
//     for (let t of templates?.value?.map((v) => v) ?? [])
//       await templateService.deleteTemplate(t.id);
//     templates.value = await templateService.readTemplates();
//   }
// };

//处理左侧nav的逻辑
const templetTypes = TemplateService.types;
const activeIndex = ref<number>(0);
const isActive = (index: number) => {
  return activeIndex.value === index;
};
const handleClick = (index: number) =>
  !isActive(index) && (activeIndex.value = index);
</script>
<style lang="less">
.modal-template-list {
  .ant-modal-content {
    border-radius: 10px;
    background-color: #000000;
    .ant-modal-header {
      border-radius: 10px 10px 0 0;
      background-color: #000000;
      .ant-modal-title {
        font-weight: 400;
      }
    }
    .ant-modal-body {
      border-radius: 0 0 10px 10px;
      overflow: hidden;
      height: 621px;
      padding: 0;
    }
  }
}
</style>
